import { Container, Row, Col } from "react-bootstrap";
import { Target, Lightbulb, Award, TrendingUp, Users, CheckCircle, Sparkles, Eye } from 'lucide-react';

function Empresa() {
    const valores = [
        {
            icon: <Award size={140} />,
            title: "Calidad",
            description: "Productos certificados de las mejores marcas internacionales"
        },
        {
            icon: <Users size={140} />,
            title: "Compromiso",
            description: "Con nuestros clientes, colaboradores y la comunidad"
        },
        {
            icon: <TrendingUp size={140} />,
            title: "Mejora Continua",
            description: "Innovación constante en procesos y servicios"
        },
        {
            icon: <CheckCircle size={140} />,
            title: "Excelencia",
            description: "En cada producto y servicio que ofrecemos"
        }
    ];

    return (
        <section className="empresa-section">
            {/* Fondo decorativo */}
            <div className="empresa-background">
                <div className="empresa-shape empresa-shape-1"></div>
                <div className="empresa-shape empresa-shape-2"></div>
                <div className="empresa-shape empresa-shape-3"></div>
                <div className="empresa-grid-pattern"></div>
            </div>

            <Container className="empresa-container">
                {/* Header */}
                <div className="empresa-header">
                    <div className="empresa-badge">
                        <Sparkles size={20} />
                        <span>Nuestra Empresa</span>
                    </div>
                    <h2 className="empresa-title">
                        Salcedo <span className="text-highlight-empresa">Importaciones</span> S.R.L
                    </h2>
                    <p className="empresa-subtitle">
                        Líderes en importación y distribución de herramientas profesionales en Bolivia
                    </p>
                    <div className="title-divider-empresa"></div>
                </div>

                {/* Misión y Visión - Cards mejoradas */}
                <Row className="g-4 mb-5 mision-vision-row">
                    {/* Misión */}
                    <Col lg={6}>
                        <div className="mv-card mision-card">
                            {/* Decoración de fondo */}
                            <div className="mv-card-decoration"></div>
                            
                            {/* Icono grande */}
                            <div className="mv-icon-wrapper">
                                <div className="mv-icon-bg"></div>
                                <Target size={60} className="mv-icon" />
                            </div>

                            {/* Contenido */}
                            <div className="mv-content">
                                <h3 className="mv-title">
                                    <Eye size={28} />
                                    Nuestra Misión
                                </h3>
                                
                                <p className="mv-text">
                                    Mantener un <strong>modelo de negocio de mejora continua</strong> para 
                                    maximizar la satisfacción de nuestros clientes a través de la{' '}
                                    <strong>excelencia en la calidad</strong> de los productos y el nivel 
                                    de nuestros servicios.
                                </p>

                                {/* Puntos clave */}
                                <div className="mv-highlights">
                                    <div className="highlight-item">
                                        <CheckCircle size={18} />
                                        <span>Mejora continua</span>
                                    </div>
                                    <div className="highlight-item">
                                        <CheckCircle size={18} />
                                        <span>Excelencia en calidad</span>
                                    </div>
                                    <div className="highlight-item">
                                        <CheckCircle size={18} />
                                        <span>Satisfacción del cliente</span>
                                    </div>
                                </div>
                            </div>

                            {/* Badge decorativo */}
                            <div className="mv-badge">Misión</div>
                        </div>
                    </Col>

                    {/* Visión */}
                    <Col lg={6}>
                        <div className="mv-card vision-card">
                            {/* Decoración de fondo */}
                            <div className="mv-card-decoration"></div>
                            
                            {/* Icono grande */}
                            <div className="mv-icon-wrapper">
                                <div className="mv-icon-bg"></div>
                                <Lightbulb size={60} className="mv-icon" />
                            </div>

                            {/* Contenido */}
                            <div className="mv-content">
                                <h3 className="mv-title">
                                    <Sparkles size={28} />
                                    Nuestra Visión
                                </h3>
                                
                                <p className="mv-text">
                                    Mantenernos como el <strong>proveedor más importante</strong> en el 
                                    mercado ferretero en Bolivia, asegurando la estabilidad de la empresa 
                                    en el largo plazo a través de un <strong>crecimiento y rentabilidad</strong> congruentes, 
                                    promoviendo y desarrollando el bienestar de todos nuestros colaboradores.
                                </p>

                                {/* Puntos clave */}
                                <div className="mv-highlights">
                                    <div className="highlight-item">
                                        <CheckCircle size={18} />
                                        <span>Liderazgo en el mercado</span>
                                    </div>
                                    <div className="highlight-item">
                                        <CheckCircle size={18} />
                                        <span>Crecimiento sostenible</span>
                                    </div>
                                    <div className="highlight-item">
                                        <CheckCircle size={18} />
                                        <span>Desarrollo de talento</span>
                                    </div>
                                </div>
                            </div>

                            {/* Badge decorativo */}
                            <div className="mv-badge">Visión</div>
                        </div>
                    </Col>
                </Row>

                {/* Sección de Valores */}
                <div className="valores-section">
                    <h3 className="valores-title">Nuestros Valores Corporativos</h3>
                    <Row className="g-4">
                        {valores.map((valor, index) => (
                            <Col md={6} lg={3} key={index}>
                                <div 
                                    className="valor-card"
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    {/* Cambiar estilos */}
                                    <div className="valor-icon-wrapper"
                                        style={{
                                        backgroundColor: "#fe5000",
                                        borderRadius: "50%",
                                        width: "200px",
                                        height: "200px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                    }}
                                    >
                                        {valor.icon}
                                    </div>
                                    <h4 className="valor-title">{valor.title}</h4>
                                    <p className="valor-description">{valor.description}</p>
                                    
                                    {/* Decoración */}
                                    <div className="valor-decoration"></div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Sección de Logros/Stats */}
                {/* <div className="logros-section">
                    <Row className="g-4 text-center">
                        {logros.map((logro, index) => (
                            <Col xs={6} lg={3} key={index}>
                                <div 
                                    className="logro-item"
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    <div className="logro-number">{logro.number}</div>
                                    <div className="logro-label">{logro.label}</div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div> */}

                {/* CTA Final */}
                <div className="empresa-cta">
                    <h3 className="cta-title-empresa">
                        ¿Quieres formar parte de nuestro equipo?
                    </h3>
                    <p className="cta-description-empresa">
                        Estamos siempre en búsqueda de talento comprometido con la excelencia
                    </p>
                    <div className="cta-buttons-empresa"> 
                        <a href="/contacto" className="btn-empresa-primary">
                            Únete a Nosotros
                        </a>
                        {/* <a href="/distribuidor" className="btn-empresa-secondary">
                            Ser Distribuidor
                        </a>                */}
                    </div>
                </div>
            </Container>
        </section>
    );
}

export default Empresa;